export const colors = {
  red: '#E82B2B',
  yellow: '#F9C92A',
  blue: '#1038EB',
  neutral: {
    100: '#F9F9F9',
    200: '#DDDDDD',
    300: '#CDCFD1',
    400: '#666666',
  },
  white: '#FFFFFF',
  black: '#000000',
  transparent: 'transparent',
} as const;

export type Colors = typeof colors;
